export const selectPosts = (state) => state.postByLocation?.postsFromFeed;
